import { Stack, Typography } from '@mui/material';
import React from 'react';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../store';

export default function TotalUser() {
  const totalUsers = useAppSelector((state) => state.users.list.totalUsers);

  const { t } = useTranslation();

  return (
    <Stack direction={'row'} gap={3} mt={1}>
      <ShowContainer condition={totalUsers || totalUsers === 0}>
        <Typography>
          {t('Users')}: {totalUsers}
        </Typography>
      </ShowContainer>
    </Stack>
  );
}
